/**
 * Entwickler-Vorschau des Frontends.
 *
 * Reines Werkzeug, um die Oberfläche ohne Docker, PostgreSQL, Redis und
 * Asterisk im Browser beurteilen zu können. Der Schalter wird ausschließlich
 * über `VITE_PREVIEW_MODE=true` gesetzt (siehe docs/dev/13_preview_mode.md).
 *
 * Vite ersetzt `import.meta.env.VITE_PREVIEW_MODE` beim Bauen durch einen
 * festen Wert. Ohne die Variable steht hier also `false`, und der Bundler
 * entfernt sämtliche Vorschau-Zweige samt der dynamisch geladenen Module aus
 * dem Produktionsbündel. In der Produktion existiert dieser Code nicht.
 */
export const PREVIEW_MODE: boolean = import.meta.env.VITE_PREVIEW_MODE === 'true';

/**
 * Hinweis im Telefoniebereich der Vorschau. Er steht hier und nicht in den
 * Sprachdateien, damit die Produktwoerterbuecher frei von Entwicklertexten
 * bleiben.
 */
export const PREVIEW_TELEPHONY_HINT =
  'Vorschaumodus: Der Telefoniebereich wird nur angezeigt. Es besteht keine Verbindung zu Asterisk, es lässt sich kein Gespräch aufbauen.';
